import React from "react";
import { connect } from 'react-redux'

import { teachersActions } from '../actions';

import { Spinner } from 'components/Icons/Spinner';
import { Row, Col } from "reactstrap";

import { CourseSubjectCard } from '../components/CourseSubjectCard';

var viewActions = require ('store/view.actions');

  


class MyCourses extends React.Component {

  componentDidMount() {
    this.props.getTeacherCourses (this.props.token,  this.props.user.persona_id , this.props.currentCalendarID) 
    this.props.setMainTitle("Mis cursos", [] )
  }

  constructor(props) {
    super(props);
    this.state = {
    }

 }

  render() {
    return (
      <>
        <div className="content">
        {!this.props.view.loadingModules.getTeacherCourses ?
            <Row>
                {this.props.teacherCourses.map( (courseSubject) => {
                            return (
                                <Col md="4">
                                    <CourseSubjectCard
                                        courseSubject={courseSubject}
                                    />
                                </Col>
                          )
                        } )
                        }
            </Row>
        :
        <Spinner size="XL" />
      }
        </div>
      </>
    );
  }
}

 const mapStateToProps = state => {
    return {
        token: state.auth.session.jwt_token,
        currentCalendarID:  state.school.currentCalendarID,
        view: state.view,
        user: state.auth.session.user,
        teacherCourses: state.teachers.teacherCourses,
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 
        getTeacherCourses: (token, personaID , calendarID) => {
            dispatch(teachersActions.getTeacherCourses(token, personaID , calendarID));
        } , 
        setMainTitle: ( title, menu ) => {
          dispatch(viewActions.setMainTitle( title, menu ))
        },
        // updatePersona: (token, personaID , data) => {
        //   dispatch(personasActions.updatePersona(token, personaID , data , false));
        // }
      
 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(MyCourses);

